import { Query } from '@varo/graphql-schema-types';
import FetchAccountIDCards from 'services/graphql/queries/FetchAccountIDCards';
import { AnyVariables, useQuery } from 'urql';

export const useFetchCardDetails = () => {
  const [{ data: sourceData, error, fetching }] = useQuery<Query, AnyVariables>(
    {
      query: FetchAccountIDCards,
      requestPolicy: 'cache-and-network',
    },
  );
  return {
    sourceData: sourceData,
    error,
    fetching,
  };
};
